import { render, staticRenderFns } from "./ModalSendTemplate.vue?vue&type=template&id=76c0f52c&scoped=true&"
import script from "./ModalSendTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalSendTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendTemplate.vue?vue&type=style&index=0&id=76c0f52c&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0f52c",
  null
  
)

export default component.exports